<template>
  <div>
    <el-dialog
      :title="selfData.id ? '编辑仓位' : '新增仓位'"
      width="680px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form ref="refForm" :config="formConfig" :column="formColumn" :data.sync="selfData" />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [Number, String],
      default: null
    },
    warehouseOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {
        id: '',
        warehouse_id: '',
        location_name: '',
        location_code: '',
        location_type: 1,
        status: 1,
        remark: '',
        deleted: false
      },
      formConfig: {
        inline: true,
        width: '300px'
      }
    }
  },
  computed: {
    formColumn() {
      return [
        { type: 'select', title: '所属仓库', field: 'warehouse_id', required: true, options: this.warehouseOptions },
        { type: 'text', title: '仓位名称', field: 'location_name', required: true, placeholder: '如 主仓-A区01' },
        { type: 'text', title: '仓位编码', field: 'location_code', disabled: true, placeholder: '保存后自动生成' },
        {
          type: 'select',
          title: '仓位类型',
          field: 'location_type',
          options: [
            { key: '货架位', val: 1 },
            { key: '地堆', val: 2 },
            { key: '暂存区', val: 3 },
            { key: '退货区', val: 4 },
            { key: '待检区', val: 5 }
          ]
        },
        {
          type: 'select',
          title: '状态',
          field: 'status',
          options: [
            { key: '启用', val: 1 },
            { key: '停用', val: 0 },
            { key: '锁定', val: 2 }
          ]
        },
        { type: 'text', title: '备注', field: 'remark' }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.id) {
      this.getDetailData()
    }
  },
  methods: {
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/warehouseLocation/getById',
        params: { id: this.id }
      }).then((res) => {
        if (res.status === 200 && res.data.formData) {
          const fd = res.data.formData
          this.selfData = {
            id: fd.id || '',
            warehouse_id: fd.warehouse_id || '',
            location_name: fd.location_name || '',
            location_code: fd.location_code || '',
            location_type:
              fd.location_type === null || fd.location_type === undefined ? 1 : Number(fd.location_type),
            status: fd.status === null || fd.status === undefined ? 1 : Number(fd.status),
            remark: fd.remark || '',
            deleted: false
          }
        }
      })
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupConfirm() {
      if (!this.selfData.warehouse_id) {
        this.$message.warning('请选择所属仓库')
        return
      }
      if (!this.selfData.location_name) {
        this.$message.warning('请填写仓位名称')
        return
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/warehouseLocation/saveOrUpdate',
        data: { form_data: this.selfData }
      })
        .then((res) => {
          if (res.data.state !== 'fail') {
            this.$message.success('保存成功')
            this.popupCancel()
            this.$emit('success')
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  padding: 10px 0;
}
</style>
